import React from 'react';
import Modal from '../../ui/modal/modal';
import Button from '../../ui/button/button';
import { useTranslation } from 'react-i18next';

export default function TransferModal({open = false, title = '', body = '', ctaLabel = '', onClick = () => {}, onClose = () => {}}) {
    const { t } = useTranslation();

    return (
        <Modal
            id='transfer'
            title={title}
            role='alertdialog'
            open={open}
            closeOnOutsideClick={true}
            submitButton={
                <Button className='neo-expiration-modal-cta' label={ctaLabel} onClick={onClick}/>
            }
            cancelButton={
                <Button className='neo-expiration-modal-cta' type='inverted-secondary' label={t('widget.button.cancel.default_label')} onClick={onClose}/>
            }
            onClose={onClose}
        >
            <p>{body}</p>
        </Modal>
    )
}
